import { FinchIntegrationManagement } from '../../Finch';
import {
  CompanySetupTabType,
  CompanySetupTabWrapper,
} from '../CompanySetupTabWrapper';

type Props = {
  employerId: string;
  isDon: boolean;
};

export const PayrollSyncTab = ({ employerId, isDon }: Props) => {
  return (
    <CompanySetupTabWrapper
      tab={CompanySetupTabType.HR_SYSTEM_SYNC}
      employerId={employerId}
      isDon={isDon}
    >
      <FinchIntegrationManagement employerId={employerId} />
    </CompanySetupTabWrapper>
  );
};
